<template>
  <div class="kontakt-container">
    <div class="kontakt-header">
      <h1>Kontakt</h1>
      <p>
        Hi, ich bin Maike, Mama von zwei kleinen Sonnenscheinen, und habe diese Community zusammen mit Freund*innen ins Leben gerufen. Wir haben uns zu häufig geärgert, dass wir erst zu spät von coolen Angeboten für Babys und frische Eltern erfahren haben, und dass es dafür keinen Infokanal gab. Darum haben wir selbst einen gegründet.
      </p><p>
        Habt ihr Fragen zur Community? Oder wollt zur Pflege der Kurs- &amp; Veranstaltungsliste beitragen? Dann meldet euch gerne bei mir. Je mehr wir sind, desto größer ist der Mehrwert für alle.
      </p>
    </div>
    <div class="kontakt-details">
      <div class="kontakt-info">
        <h2>Maikes Familienbegleitung</h2>
        <p>Website: <a href="https://maikes-familienbegleitung.de" aria-label="Zur Website von Maikes Familienbegleitung" target="_blank" rel="noopener">maikes-familienbegleitung.de</a></p>
        <p>E-Mail: <a href="mailto:info@maikes-familienbegleitung.de" aria-label="E-Mail an Maikes Familienbegleitung" target="_blank" rel="noopener">info@maikes-familienbegleitung.de</a></p>
        <p>Telefon: <a href="tel:+4915773577671" aria-label="Maikes Familienbegleitung anrufen" target="_blank" rel="noopener">+49 1577 3577671</a></p>
        <p>WhatsApp: <a href="https://wa.me/4915773577671?text=Liebe%20Maike%2C%20ich%20habe%20eine%20Frage%20zu%20..." aria-label="WhatsApp Chat mit Maikes Familienbegleitung starten" target="_blank" rel="noopener">WhatsApp öffnen</a></p>
        <p>Instagram: <a href="https://www.instagram.com/maikes_familienbegleitung" aria-label="Maikes Familienbegleitung bei Instagram" target="_blank" rel="noopener">@maikes_familienbegleitung</a></p>
        <p>56072 Koblenz-Metternich</p>
        <KontaktButton />
      </div>
    </div>
    <div class="hero-image">
      <img src="@/assets/maike_kontakt.jpg" alt="Maike Röhrig – Familienbegleitung Koblenz" width="300" height="auto"/>
    </div>
  </div>
</template>
 
<script>
  import KontaktButton from '@/components/KontaktButton.vue';

  export default {
    name: 'Kontakt',
    components: {
      KontaktButton
    }
  }
</script>

 
<style scoped>
.kontakt-container {
  padding: 1.25rem; /* 20px */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.kontakt-header {
  flex: 1;
  min-width: 300px;
  margin-right: 1.25rem; /* 20px */
  flex-direction: row;
}

.kontakt-details {
  flex: 1;
  min-width: 300px;
  margin-right: 1.25rem; /* 20px */
  flex-direction: row;
}
 
.kontakt-info {
  margin-bottom: 1.25rem; /* 20px */
}
 
.kontakt-formular {
  flex: 2;
  min-width: 300px;
}
 
.bild-placeholder {
  width: 100%;
  height: 400px;
  background-color: #ccc;
  margin-bottom: 1.25rem; /* 20px */
}
 
form {
  display: flex;
  flex-direction: column;
}
 
label {
  margin-top: 10px;
}
 
input, textarea {
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
 
.checkbox-container {
  display: flex;
  align-items: center;
}
 
button {
  margin-top: 1.25rem; /* 20px */
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
 
button:hover {
  background-color: #0056b3;
}
 
@media (max-width: 40rem) {
  .kontakt-inhalt {
    flex-direction: column;
  }
  .kontakt-details {
    margin-right: 0;
  }
}
</style>